<template>
  <v-container fluid>
    <v-row>
      <v-col class="main_title">
        <v-flex tag="h2" class="text-uppercase primary-text">
          Value Stream Metrics
          <v-tooltip bottom>
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-bind="attrs" v-on="on">
                information
              </v-icon>
            </template> -->
            <span>Value Stream Metrics</span>
          </v-tooltip>
        </v-flex>
        <v-divider class="mt-4" />
      </v-col>
    </v-row>
    <v-row class="no-gutters align-center">
      <v-col md="4">
        <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="search"
          class="search-control"
          @keyup="getVsmList(), pageReset()"
        />
      </v-col>
      <v-col class="text-right">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="resetAll" class="mr-1">
              <v-icon>restart_alt</v-icon>
            </v-btn>
            <v-btn v-bind="attrs" v-on="on" class="tertiary-btn">
              <v-icon left>mdi-filter-variant</v-icon>
              Filter
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in category"
              :key="index"
              link
              @click="filter(item)"
            >
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn class="tertiary-btn hidden">
          <v-icon left>mdi-plus</v-icon>
          Add Metric
        </v-btn>
        <v-form ref="form" v-model="valid" class="form-right-view-lable">
          <v-dialog v-model="dialogueMetric" persistent max-width="800px">
            <v-card class="custom-dialog">
              <v-container>
                <v-card-title>
                  <span class="text-h5 text-uppercase font-weight-bold"
                    >Add Metric</span
                  >
                  <v-spacer></v-spacer>
                  <v-btn icon color="black" @click="dialogueMetric = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <v-divider class="mb-10" />
                  <v-row class="no-gutters">
                    <v-col cols="6">
                      <v-select
                        v-model="selectedMetricUnique"
                        :item-text="(item) => item.metricName"
                        :items="listMetrics"
                        :item-value="(item) => item.metricUniqueName"
                        filled
                        :rules="[(v) => !!v || 'This field is required']"
                        label="Metrics"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-row class="no-gutters">
                    <v-col cols="6">
                      <v-select
                        v-model="selectedCategory"
                        :items="category"
                        :rules="[(v) => !!v || 'This field is required']"
                        filled
                        label="Category"
                        required
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-container>
                  <v-divider />
                </v-container>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    class="secondary-btn"
                    text
                    @click="dialogueMetric = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :disabled="!valid || buttonCheck()"
                    text
                    class="primary-btn"
                    @click="addMetric()"
                  >
                    Add Metric
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="custom-simple-table">
      <v-col>
        <!-- <v-data-table
          id="metrics"
          :headers="headers"
          :items="vsmList.data"
          :options.sync="options"
          :server-items-length="vsmList.total"
          :loading="loading"
          hide-default-footer
        >
          <template v-slot:item.metricName="{ item }">
            {{ item.metricName }}
          </template>
          <template v-slot:item.category="{ item }">
            {{ item.category }}
          </template>
          <template v-slot:item.createdDate="{ item }">
            {{ moment(item.createdDate) }}
          </template>
          <template v-slot:item.isActive="{ item }">
            <v-switch
              v-model="item.isActive"
              color="success"
              value
              hide-details
              :disable="!item.isActive"
              @update:model-value="updateMetricStatus(item.id, item.isActive)"
            ></v-switch>
          </template>
          <template v-slot:item.action="{ item }">
            <v-row>
              <v-col cols="6">
                <v-btn icon>
                  <v-icon @click="editDialog(item)">edit</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
        <div class="primary-icon">
          <license-pagination
            :total="vsmList.totalCount"
            :value="page"
            @input="pageEmit"
          />
        </div> -->
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"> Metric Name </th>
                <th class="text-left"> Category </th>
                <th class="text-left"> Created Date </th>
                <th class="text-left"> Active/InActive </th>
                <!-- <th class="text-left hidden"> Action </th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in vsmList.data" :key="index">
                <td>{{ item.metricName }}</td>
                <td>{{ item.category }}</td>
                <td>{{ moment(item.createdDate) }}</td>
                <td>
                  <!-- <v-chip label text-color="black"> -->
                  <v-switch
                    v-model="item.isActive"
                    color="success"
                    value
                    hide-details
                    disabled
                  ></v-switch>
                  <!-- <v-icon left> mdi-check-circle </v-icon>
                    Avaliable -->
                  <!-- </v-chip> -->
                </td>
                <td class="text-center hidden">
                  <v-btn icon>
                    <v-icon>mdi-square-edit-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-dialog v-model="editMetric" persistent max-width="800px">
          <v-card class="custom-dialog">
            <v-container>
              <v-card-title>
                <span class="text-h5 text-uppercase font-weight-bold"
                  >Edit Metric</span
                >
                <v-spacer></v-spacer>
                <v-btn icon color="black" @click="editMetric = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-divider class="mb-10" />
                <v-row class="no-gutters">
                  <v-col cols="6">
                    <v-select
                      v-model="editMetricName"
                      :item-text="(item) => item.metricName"
                      :items="listMetrics"
                      :item-value="(item) => item.metricUniqueName"
                      :disabled="true"
                      filled
                      label="Metric Name"
                    />
                  </v-col>
                </v-row>
                <v-row class="no-gutters">
                  <v-col cols="6">
                    <v-select
                      v-model="editCategoryName"
                      :items="category"
                      filled
                      label="Category"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- <v-card-text>
                <v-divider class="mb-10" />
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="first" label="Metric Name" filled />
                  </v-col>
                  <v-col cols="6">
                    <v-select :items="Metrics" filled label="Category" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-select :items="Group" filled label="Tool" />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="first" label="Formula" filled />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      name="input-7-1"
                      filled
                      label="Description"
                      auto-grow
                    />
                  </v-col>
                </v-row>
              </v-card-text> -->
              <v-container>
                <v-divider />
              </v-container>
              <v-card-actions>
                <v-spacer />
                <v-btn class="secondary-btn" text @click="editMetric = false">
                  Cancel
                </v-btn>
                <v-btn text class="primary-btn" @click="updateVsmMetric()">
                  Save
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
import { storeActions } from '@/store/actions.constants';
export default {
  components: { licensePagination },
  data: () => ({
    headers: [
      {
        text: 'METRIC NAME',
        align: 'start',
        value: 'metricName',
        sortable: false,
      },
      {
        text: 'CATEGORY',
        align: 'start',
        value: 'category',
        sortable: false,
      },
      {
        text: 'CREATED DATE',
        align: 'start',
        value: 'createdDate',
        sortable: false,
      },
      {
        text: 'ACTIVE/INACTIVE',
        align: 'start',
        value: 'isActive',
        sortable: false,
      },
    ],
    dialogueMetric: false,
    editMetric: false,
    items: [
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me' },
    ],
    Metrics: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    category: [
      'Sprint Quality',
      'Sprint Completion Rate',
      '14 day Health Pipeline',
    ],
    first: '',
    loading: false,
    page: 1,
    options: {},
    listMetrics: [],
    selectedMetricUnique: null,
    selectedCategory: null,
    search: '',
    editMetricName: null,
    editCategoryName: null,
    metricObj: {},
    updateMetricObj: {},
    valid: false,
    editMetricId: '',
    updateMetricObjStatus: {},
    toggle: false,
  }),
  computed: {
    ...mapGetters({
      vsmList: 'valueStreamMetrics/getVsmsList',
      getVsmMetricList: 'valueStreamMetrics/getVsmMetricList',
    }),

    metricsList() {
      return this.listMetrics.map((uniqueName) => ({
        metricUniqueName: uniqueName.metricUniqueName,
      }));
    },
  },
  async mounted() {
    await this.getVsmList();
    let res = await this.getVsmMetric();
    this.listMetrics = res.data.metrics;
  },
  methods: {
    ...mapActions({
      getVsms: 'valueStreamMetrics/getVsms',
      getVsmMetric: 'valueStreamMetrics/getVsmMetric',
      addVsmMetric: 'valueStreamMetrics/addVsmMetric',
      saveVsmMetric: 'valueStreamMetrics/updateVsmMetric',
      updateVsmMetricStatus: 'valueStreamMetrics/updateVsmMetricStatus',
    }),
    updateMetricStatus(id, isEnabled) {
      if (isEnabled == false) {
        isEnabled = 0;
      } else {
        isEnabled = 1;
      }
      this.updateVsmMetricStatus({
        page: 1,
        limit: 20,
        vsmMetricId: id,
        isActive: isEnabled,
      }).then((res) => {
        if (res.status === 200) {
          this.toggle = true;
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: 'VSM Metric Status Updated Successfully',
            timeout: 5000,
            color: 'success',
          });
        } else {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 5000,
            color: 'error',
          });
        }
      });
    },

    filter(value) {
      if (value) {
        this.page = 1;
      }
      this.getVsms({
        page: this.page,
        limit: 20,
        search: this.search || '',
        filter: value,
      }).then((res) => {
        if (res.status === 200) {
          let items = res.data.data;
          this.loading = false;
        }
      });
    },
    openDialogue() {
      this.$refs.form.resetValidation();
      this.dialogueMetric = true;
      this.selectedMetricUnique = null;
      this.selectedCategory = null;
    },
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) this.page = data;
      this.getVsmList();
    },
    resetAll() {
      this.search = '';
      this.filter('');
      this.page = 1;
      this.getVsmList();
    },
    async addMetric() {
      this.metricObj = await this.addVsmMetric({
        metricUniqueName: this.selectedMetricUnique,
        category: this.selectedCategory,
      });
      if (this.metricObj.status === 200) {
        this.dialogueMetric = false;
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Metric Added Successfully',
          timeout: 5000,
          color: 'success',
        });
        this.getVsmList();
      } else {
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: this.metricObj.data.message,
          timeout: 5000,
          color: 'error',
        });
      }
    },
    getVsmList() {
      this.loading = true;
      this.getVsms({
        page: this.page,
        limit: 20,
        search: this.search || '',
      })
        .then((res) => {
          if (res.status === 200) {
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    editDialog(value) {
      this.editMetric = true;
      this.editMetricName = value.metricUniqueName;
      this.editMetricId = value.id;
      this.editCategoryName = value.category;
    },
    async updateVsmMetric() {
      this.updateMetricObj = await this.saveVsmMetric({
        vsmMetricId: this.editMetricId,
        category: this.editCategoryName,
      });
      if (this.updateMetricObj.status === 200) {
        this.editMetric = false;
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Metric Updated Successfully',
          timeout: 5000,
          color: 'success',
        });
        this.getVsmList();
      } else {
        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: this.updateMetricObj.data.message,
          timeout: 5000,
          color: 'error',
        });
      }
    },
    buttonCheck() {
      // var check = (val) => val.check === false;
      if (this.selectedMetricUnique == null || this.selectedCategory == null) {
        return true;
      } else {
        return false;
      }
    },
    moment: function (value) {
      return moment(value).format('DD MMMM YYYY');
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/colors.scss';
.main_title {
  h2 {
    .v-icon {
      font-size: 24px;
      position: relative;
      top: -1px;
    }
  }
}
.search-control {
  .v-input__prepend-inner {
    padding-right: 8px !important;
    border-right: 1px solid $secondary-color-5;
    margin-right: 8px !important;
  }
}
.primary-btn,
.secondary-btn {
  min-width: 140px !important;
  text-transform: uppercase !important;
  border-radius: 0px !important;
  font-size: 0.9rem !important;
}
.primary-btn {
  background-color: $primary-button;
  color: $white !important;
}
.secondary-btn {
  background-color: transparent !important;
  border: 1px solid $seconday-button !important;
  color: $seconday-button !important;
}
.tertiary-btn {
  box-shadow: none;
  background-color: transparent !important;
  font-size: 1rem !important;
  text-transform: uppercase;
}
.v-dialog,
.custom-dialog {
  border-radius: 0px !important;
}
.custom-dialog {
  .v-card__text {
    min-height: 300px;
  }
  .v-input__control {
    border-radius: 0px;
  }
}
.custom-simple-table {
  table {
    border: 1px solid rgba($primary-table, 0.4);
    tr {
      &:hover {
        background: transparent !important;
      }
    }
    th,
    td {
      border-right: 1px solid rgba($primary-table, 0.4);
      padding: 14px;
      :last-child {
        border-right: 1px solid transparent;
      }
    }
    th {
      text-transform: uppercase;
      background-color: rgba($primary-table, 0.3);
      color: $black !important;
    }
    td {
      .v-chip.v-size--default {
        background-color: $secondary-color-6;
        border-radius: 16px !important;
        height: auto !important;
        color: $secondary-color-7 !important;
        .v-icon {
          margin-left: -12px !important;
          color: $secondary-color-7;
        }
      }
    }
  }
}
</style>